<template>
  <div>
    <!-- HEAD -->

    <div class="head row p-0 g-0" data-aos="fade-in" data-aos-delay="100" data-aos-duration="3000" >
      <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 col-xxl-7 p-0">
        <img :src="`${publicPath}img/01transformacioHead.jpg`" class="img-responsive">
      </div>
      <div class="headRight p-3 pt-xl-2 px-xl-5 px-xxl-0 ps-xxl-5">
        <div class="row justify-content-end">
          <div class="col-2 m-0 me-3  mb-4 mt-3 p-0">
            <img :src="`${publicPath}img/01transformacion-headIcon.gif`" class="img-responsive">
          </div>
        </div>
        <h2 v-html="$t('trans.transformacion-digital')"></h2>
        <p class="text-end pt-2 pt-xl-3">{{ $t('trans.intro') }}</p>
      </div>
    </div>

    <!-- end HEAD -->

    <div class="contingut bg-white row g-0">
      <div class="row g-0">
        <div class="col-11 col-lg-10 m-auto pb-5">
          <div class="row justify-content-evenly g-0 pt-5 pb-1">
            <div class="col-12 col-lg-6 text-center text-lg-start pe-0 pe-lg-5" data-aos="fade-up" data-aos-duration="600">
              <h3 class="text-blau pb-3 pe-0 pe-lg-5">{{ $t('trans.tit1') }}</h3>
              <p v-html="$t('trans.txt1')"></p>
            </div>
            <div class="col-12 col-lg-6 text-center text-lg-end" data-aos="fade-up" data-aos-duration="1000">
              <img :src="`${publicPath}img/01transformacionExperiencias.jpg`" class="img-responsive mb-5">
            </div>
          </div>
          <hr class="bg-darkBlue">

          <div class="row g-0">
              <div class="col-12 m-auto my-5 fonsGris">
                <div class="row g-0">
                  <div class="col-12 col-lg-6 p-5 text-center text-xl-start">
                    <h4>{{ $t('trans.tit2') }}</h4>
                    <p>{{ $t('trans.txt2') }}</p>
                    <p class="text-end"><a href="https://www.laufenvirtualspace.com" target="_blank"><span class="btnCollapseIn btnFosc me-0 external-link"><i class="fa-solid fa-link"></i></span></a></p>
                  </div>
                  <div class="col-12 col-lg-6 text-end p-0 bg-foto" :style="{ backgroundImage: `url(${publicPath}img/01innovacionLaufen.jpg)` }"></div>
                </div>
            </div>
          </div>
          <hr class="bg-darkBlue">
          <div class="row justify-content-evenly g-0 pt-5 pb-1">
            <div class="col-12 col-lg-6 text-center text-lg-start pe-0 pe-lg-5" data-aos="fade-up" data-aos-duration="600">
              <h3 class="text-blau pb-3 pe-0 pe-lg-5">{{ $t('trans.tit3') }}</h3>
              <p>{{ $t('trans.txt3') }}</p>
              <p><strong>{{ $t('trans.portal-de-proveedores') }}</strong> {{ $t('trans.txta') }}</p>
              <p><strong>{{ $t('trans.servicio-de-posventa') }}</strong> {{ $t('trans.txtb') }}</p>
              <p><strong>{{ $t('trans.venta-de-recambios') }}</strong> {{ $t('trans.txtc') }}</p>
            </div>
            <div class="col-12 col-lg-6 text-center text-lg-end" data-aos="fade-up" data-aos-duration="1000">
              <img :src="`${publicPath}img/01transformacionCanales.jpg`" class="img-responsive mb-5">
            </div>
          </div>
          <hr class="bg-darkBlue">
          <div class="row fonsGris mt-5">
            <div class="row g-0 text-center text-lg-start p-5">
              <h4>{{ $t('trans.tit4') }}</h4>
              <p>{{ $t('trans.txt4') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="contingut bg-white row g-0 mb-5 pb-5">
      <div class="col-12 py-5 mb-5 fonsGris position-relative">
        <h3 class="pb-3 mb-3">{{ $t('contribucion-a-los-ods') }}</h3>
        <div class="row justify-content-center">
          <div class="col-12 col-lg-4 col-xl-3 col-md-auto mb-4 text-center text-lg-start">
            <p>{{ $t('impacto-directo') }}</p>
            <img :src="`${publicPath}img/01transformacion-icono01.gif`" class="img-responsive m-1">
            <img :src="`${publicPath}img/01transformacion-icono02.gif`" class="img-responsive m-1">
            <img :src="`${publicPath}img/01crecimiento-icono04.gif`" class="img-responsive m-1">
            <img :src="`${publicPath}img/01excelencia-icono03.gif`" class="img-responsive m-1">
          </div>
          <div class="col-md-auto border-start mb-4 text-center text-lg-start">
            <p>{{ $t('impacto-indirecto') }}</p>
            <img :src="`${publicPath}img/01excelencia-icono04.gif`" class="img-responsive m-1">
            <img :src="`${publicPath}img/01crecimiento-icono06.gif`" class="img-responsive m-1">
            <img :src="`${publicPath}img/01excelencia-icono07.gif`" class="img-responsive m-1">
            <img :src="`${publicPath}img/01transformacion-icono08.gif`" class="img-responsive m-1">
          </div>
        </div>
      </div>

      <hr>
      <div class="row p-0 g-0">
        <div class="col-6 p-3 p-lg-0 m-0 pb-3 text-start">
          <localized-link class="footerLink" to="/avanzando-hacia-el-futuro/innovacion"><img :src="`${publicPath}img/breadcrumbBack.gif`" class="img-responsive" width="6"> {{ $t("nav.innovacion") }}</localized-link>
        </div>
        <div class="col-6 p-3 p-lg-0 m-0 pb-3 text-end">
          <localized-link class="footerLink" to="/avanzando-hacia-el-futuro/sostenibilidad">{{ $t("nav.sostenibilidad") }} <img :src="`${publicPath}img/breadcrumbGo.gif`" class="img-responsive" width="6"></localized-link>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
  export default {
    name: "TransformacionDigitalView",
    data() {
      return {
        publicPath: process.env.BASE_URL
      }
    }
  }

</script>
